import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../assets/PricingCard.css";
import Swal from "sweetalert2";
import {useNavigate, useParams} from "react-router-dom";
import {AlertTriangle} from "lucide-react";
import {plans_pl, plans_pm, security} from "../env/Environment";
import {Ajax} from "../Service/ajax";

const PricingCard2 = ({subscriptions}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { pageUrl } = useParams();

    const session = sessionStorage.getItem("session");
    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);

    const tiers = [
        { id:plans_pl.basic,volume: "Moins de 50 000 $", additional: 4.7, name:"Basic" },
        { id:plans_pl.standard,volume: "De 50 000 à 100 000 $", additional: 4.0, name:"Standard" },
        { id:plans_pl.pro,volume: "De 100 000 à 200 000 $", additional: 3.7, name:"Pro" },
        { id:plans_pl.entreprise,volume: "Plus de 200 000 $", additional: 3.5, name:"Entreprise" },
    ];


    const fetchData = async (subscription)=>{
        try {
            const {data} = await Ajax.postRequest("/api/v1/sub/subscription/"+subscription.id+"/subscribe", []);
            if(data.error){
                Swal.fire({
                    title: 'Error!',
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }else{
                Swal.fire({
                    title: 'Success!',
                    text: `Abonnement au reussi`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }
        }catch (error){
            console.log(error)
            Swal.fire({
                title: 'Error!',
                text: "Oups! Une erreur s'est produite, veuillez reesayer plus tard.",
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000
            });
        }
    }



    const handleSubscribe = () => {
        if(session) {
            Swal.fire({
                title: 'Message important',
                text: "Vous êtes sur le point de vous abonner à ce service. Soyez rassurés que toute  information personnelle qui vous sera demandée sera gardée privée et traitée conformément à notre politqie de confidentialité !",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor:'#debf66',
                focusConfirm:true,
                confirmButtonText: 'Continuer',
                cancelButtonText:'Annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    let selected = subscriptions.find(subscription => subscription.id === tiers[activeIndex].id);
                    fetchData(selected);
                }
            })
        }else{
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login?target=subs")
            }else{
                navigate(`/login?target=own-page&target_id=${pageUrl}`);
            }
        }
    }




    const handleSliderChange = (event) => {
        setActiveIndex(Number(event.target.value));
    };

    return (
        <motion.section
            className="bg-white shadow-lg rounded-3 mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="p-4 h-px-150">
                <h1 className="h3 font-weight-bold text-dark mb-3">Payez à l'utilisation</h1>
                <p className="text-muted mb-6">
                    Payez seulement ce que vous utilisez, sans frais récurrents. Idéal pour un volume faible ou imprévisible.
                </p>
            </div>

            <div className="p-4 h-px-250" style={{ backgroundColor: "#f6f6f6" }}>
                <div className="h-px-30">
                    <p className="text-muted flex items-center">
                        <AlertTriangle className="w-4 h-4 text-yellow-500 mr-2" />
                        Offre valable pour un revenu mensuel allant jusqu’à 10 000$
                    </p>
                </div>
                {/* Pricing Info */}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeIndex}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        <h2 className="h1 font-weight-bold text-dark mt-3">
                            {tiers[activeIndex].additional}%
                        </h2>

                        <p className="text-muted small">
                            {tiers[activeIndex].additional}% seront déduits sur toutes les transactions.
                        </p>
                    </motion.div>
                </AnimatePresence>

                {/* Slider with Progress Bar and Dots */}
                <div className="w-100 d-flex flex-column align-items-center">
                    <div className="position-relative w-100">

                    </div>
                </div>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeIndex}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        <h2 className="h1 font-weight-bold text-dark mt-3">

                        </h2>
                    </motion.div>
                </AnimatePresence>
            </div>

            <div className="p-4" style={{ backgroundColor: "#f6f6f6" }}>
                {/* Contact Button */}
                <motion.button
                    className="mt-4 btn btn-lg btn-netikash text-white rounded-lg shadow-sm hover-shadow"
                    whileHover={{ scale: 1.05 }}
                    onClick={handleSubscribe}
                >
                    S'abonner
                </motion.button>
            </div>
        </motion.section>
    );
};

export default PricingCard2;